<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <BreadCrumb
          :parentRouteName="isBranchProduct ? 'BranchProductList' : 'ProductList'" 
          :extra-items="readonly ? [
            {
              text: product.title ?? ''
            }
          ] : isEdit ? [
            {
              text: product.title ?? '',
              to: 'ProductDetailV2',
              params: $route.params.product_id
            },
            '編輯商品'
          ] : [
            '新增商品'
          ]"
        />
      </div>
    </div>

    <b-card>
      <b-overlay :show="showLoading" rounded="sm">
        <div class="row mb-2 align-items-center">
          <div class="col-12 col-xl-2">
            <h4 class="font-weight-bold">商品明細</h4>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <b-form-group :disabled="readonly || !canEditAllFields">
              <b-form-group
                label-cols="12"
                label-cols-lg="1"
                label-size="m"
                content-cols="12"
                content-cols-lg="11"
                label="分店"
                v-if="isBranchProduct"
              >
                <AppSingleSelect
                  class="mr-3"
                  v-model="selectedBranch"
                  :options="branchOptions"
                  @input="handleBranchChange"
                />
              </b-form-group>

              <b-form-group
                label-cols="12"
                label-cols-lg="1"
                label-size="m"
                content-cols="12"
                content-cols-lg="11"
                label="商品名稱"
              >
                <b-form-input v-model="product.title"></b-form-input>
              </b-form-group>

              <b-form-group
                label-cols="12"
                label-cols-lg="1"
                label-size="m"
                content-cols="12"
                content-cols-lg="11"
                label="商品說明"
              >
                <b-form-input v-model="product.description"></b-form-input>
              </b-form-group>
            </b-form-group>
          </div>
          <div class="col-6">
            <b-form-group :disabled="readonly || !canEditAllFields">
              <b-form-group
                label-cols="12"
                label-cols-lg="2"
                label-size="m"
                content-cols="12"
                content-cols-lg="6"
                label="商品序號"
              >
                <b-form-input v-model="product.product_code"></b-form-input>
              </b-form-group>
              <b-form-group
                label-cols="12"
                label-cols-lg="2"
                label-size="m"
                content-cols="12"
                content-cols-lg="6"
                label="商品分類"
              >
                <b-form-input v-model="product.category"></b-form-input>
              </b-form-group>
              <b-form-group
                label-cols="12"
                label-cols-lg="2"
                label-size="m"
                content-cols="12"
                content-cols-lg="6"
                label="售價"
              >
                <b-form-input type="number" v-model="product.price"></b-form-input>
              </b-form-group>
              <b-form-group
                label-cols="12"
                label-cols-lg="2"
                label-size="m"
                content-cols="12"
                content-cols-lg="6"
                label="原價"
              >
                <b-form-input type="number" v-model="product.original_price"></b-form-input>
              </b-form-group>
              <b-form-group
                label-cols="12"
                label-cols-lg="2"
                label-size="m"
                content-cols="12"
                content-cols-lg="6"
                label="點數"
              >
                <b-form-input type="number" v-model="product.point"></b-form-input>
              </b-form-group>
            </b-form-group>
          </div>
          <div class="col-6">
            <b-form-group :disabled="readonly || !canEditAllFields">
              <b-form-group
                label-cols="12"
                label-cols-lg="3"
                label-size="l"
                content-cols="12"
                content-cols-lg="8"
                label="開始販售時間"
              >
                <div class="d-flex">
                  <div class="w-50">
                    <datepicker
                      :placeholder="readonly ? '' : '請選擇日期'"
                      v-model="product.available_start_at.date"
                      bootstrap-styling
                      format="yyyy-MM-dd"
                      :language="zh"
                    ></datepicker>
                  </div>
                  <div class="ml-2 w-50">
                    <vue-timepicker
                      format="HH:mm"
                      v-model="product.available_start_at.time"
                      :input-class="['form-control']"
                      :placeholder="readonly ? ' ' : 'HH:mm'"
                    ></vue-timepicker>
                  </div>
                </div>
              </b-form-group>
              <b-form-group
                label-cols="12"
                label-cols-lg="3"
                label-size="l"
                content-cols="12"
                content-cols-lg="8"
                label="結束販售時間"
              >
                <div class="d-flex">
                  <div class="w-50">
                    <datepicker
                      :placeholder="readonly ? '' : '請選擇日期'"
                      v-model="product.available_end_at.date"
                      bootstrap-styling
                      format="yyyy-MM-dd"
                      :language="zh"
                    ></datepicker>
                  </div>
                  <div class="ml-2 w-50">
                    <vue-timepicker
                      format="HH:mm"
                      v-model="product.available_end_at.time"
                      :input-class="['form-control']"
                      :placeholder="readonly ? ' ' : 'HH:mm'"
                    ></vue-timepicker>
                  </div>
                </div>
              </b-form-group>
              <b-form-group
                label-cols="12"
                label-cols-lg="3"
                label-size="m"
                content-cols="12"
                content-cols-lg="6"
                label="是否上架"
              >
                <b-form-checkbox v-model="product.is_enabled" switch></b-form-checkbox>
              </b-form-group>
              <b-form-group
                label-cols="12"
                label-cols-lg="3"
                label-size="m"
                content-cols="12"
                content-cols-lg="6"
                label="商品類型"
              >
                <b-form-radio-group v-model="product.type" :options="productTypeOptions">
                </b-form-radio-group>
              </b-form-group>
            </b-form-group>
          </div>
        </div>
        <div class="row mt-4 mb-2 align-items-center">
          <div class="col-12 col-xl-2">
            <h4 class="font-weight-bold">商品規格</h4>
          </div>
        </div>
        <div class="text-right" v-if="canEditAllFields">
          <b-button
            class="flex-shrink-0 mb-2 mb-xl-0 ml-2 py-2"
            variant="primary"
            @click="addSkuHandler"
          ><i class="fa fa-plus" aria-hidden="true"></i
          >新增規格
          </b-button
          >
        </div>
        <b-table striped hover :items="product.skus" :fields="fields">
          <template #cell(sku_code)="data">
            <div v-if="readonly || !canEditAllFields">
              {{ data.item.sku_code }}
            </div>
            <div v-else>
              <b-form-group
                label-cols="12"
                label-cols-sm="0"
                label-size="sm"
                content-cols="12"
                content-cols-sm="12">
                <b-form-input v-model="data.item.sku_code"></b-form-input>
              </b-form-group>
            </div>
          </template>
          <template #cell(sku_name)="data">
            <div v-if="readonly || !canEditAllFields">
              {{ data.item.sku_name }}
            </div>
            <div v-else>
              <b-form-group
                label-cols="12"
                label-cols-sm="0"
                label-size="sm"
                content-cols="12"
                content-cols-sm="12">
                <b-form-input v-model="data.item.sku_name"></b-form-input>
              </b-form-group>
            </div>
          </template>
          <template #cell(sku_outer_code)="data">
            <div v-if="readonly || !canEditAllFields">
              {{ data.item.sku_outer_code }}
            </div>
            <div v-else>
              <b-form-group
                label-cols="12"
                label-cols-sm="0"
                label-size="sm"
                content-cols="12"
                content-cols-sm="12">
                <b-form-input v-model="data.item.sku_outer_code"></b-form-input>
              </b-form-group>
            </div>
          </template>
          <template #cell(max_quantity)="data">
            <div v-if="readonly || !canEditStockFields">
              {{ data.item.max_quantity }}
            </div>
            <div v-else>
              <b-form-group
                label-cols="12"
                label-cols-sm="0"
                label-size="sm"
                content-cols="12"
                content-cols-sm="12">
                <b-form-input type="number" v-model="data.item.max_quantity"></b-form-input>
              </b-form-group>
            </div>
          </template>
          <template #cell(quantity)="data">
            <div v-if="readonly || !canEditStockFields">
              {{ data.item.quantity }}
            </div>
            <div v-else>
              <b-form-group
                label-cols="12"
                label-cols-sm="0"
                label-size="sm"
                content-cols="12"
                content-cols-sm="12">
                <b-form-input type="number" v-model="data.item.quantity"></b-form-input>
              </b-form-group>
            </div>
          </template>
          <template #cell(suggest_price)="data">
            <div v-if="readonly || !canEditAllFields">
              {{ data.item.suggest_price }}
            </div>
            <div v-else>
              <b-form-group
                label-cols="12"
                label-cols-sm="0"
                label-size="sm"
                content-cols="12"
                content-cols-sm="12">
                <b-form-input type="number" v-model="data.item.suggest_price"></b-form-input>
              </b-form-group>
            </div>
          </template>
          <template #cell(price)="data">
            <div v-if="readonly || !canEditAllFields">
              {{ data.item.price }}
            </div>
            <div v-else>
              <b-form-group
                label-cols="12"
                label-cols-sm="0"
                label-size="sm"
                content-cols="12"
                content-cols-sm="12">
                <b-form-input type="number" v-model="data.item.price"></b-form-input>
              </b-form-group>
            </div>
          </template>
          <template #cell(point)="data">
            <div v-if="readonly || !canEditAllFields">
              {{ data.item.point }}
            </div>
            <div v-else>
              <b-form-group
                label-cols="12"
                label-cols-sm="0"
                label-size="sm"
                content-cols="12"
                content-cols-sm="12">
                <b-form-input type="number" v-model="data.item.point"></b-form-input>
              </b-form-group>
            </div>
          </template>
          <template #cell(action)="data">
            <div class="d-flex justify-content-center">
              <b-button :disabled="readonly || !canEditAllFields" variant="inverse-danger" size="sm" @click="() => delete1(data.index)">
                刪除
              </b-button>
            </div>
          </template>
        </b-table>
        <div class="d-flex justify-content-center" v-if="!readonly && canEditAnyFields" style="margin-top: 80px">
          <b-button class="mr-4" variant="outline-danger" @click="handleCancel">
            <template>返回</template>
          </b-button>
          <b-button variant="success" @click="handleSubmit">
            <template v-if="isEdit">確認編輯</template>
            <template v-if="isCreate">確認新增</template>
          </b-button>
        </div>
      </b-overlay>
    </b-card>
  </div>
</template>

<script>
import productApi from "../../../../apis/product";
import Datepicker from "vuejs-datepicker";
import {zh} from "vuejs-datepicker/dist/locale";
import branchApi from "../../../../apis/branch";
import { mapGetters, mapState } from "vuex";
import getHours from "date-fns/getHours/index";
import getMinutes from "date-fns/getMinutes/index";
import VueTimepicker from "vue2-timepicker";
import {format, set, formatISO} from "date-fns";
import AppSingleSelect from "@/components/AppSingleSelect.vue";
import BreadCrumb from "@/components/Dashboard/BreadCrumb";
import PermissionChecker from "@/utils/PermissionChecker";
import * as consts from "@/consts";

export default {
  components: {AppSingleSelect, Datepicker, VueTimepicker,BreadCrumb},
  data() {
    return {
      zh,
      consts,
      permissionChecker: new PermissionChecker(),
      showLoading: false,
      isBranchProduct: false,
      selectedBranch: null,
      product: {
        merchant_id: null,
        available_start_at: {
          date: new Date(),
          time: {
            HH: "23",
            mm: "59",
          },
        },
        available_end_at: {
          date: new Date(),
          time: {
            HH: "23",
            mm: "59",
          },
        },
        skus: [],
        is_enabled: true,
        type: "normal"
      },
      fields: [
        {key: "sku_code", label: "規格序號", class: 'narrow-col'},
        {key: "sku_name", label: "規格名稱", class: 'wide-col'},
        {key: "sku_outer_code", label: "外部規格序號", class: 'narrow-col'},
        {key: "max_quantity", label: "原始總量", class: 'narrow-col'},
        {key: "quantity", label: "可售庫存", class: 'narrow-col'},
        {key: "suggest_price", label: "售價", class: 'narrow-col'},
        {key: "price", label: "原價", class: 'narrow-col'},
        {key: "point", label: "點數", class: 'narrow-col'},
        {key: "action", label: "管理", class: 'narrow-col'},
      ],
      branches: [],
      productTypeOptions: [
        {text: '一般', value: 'normal'},
        {text: '團購品', value: 'groupbuying'},
        {text: '實體', value: 'physical'},
        {text: '虛擬', value: 'virtual'},
        {text: '服務', value: 'service'},
        {text: '贈品', value: 'gift'},
        {text: '兌換品', value: 'redeem_gift'},
        {text: '線上課程', value: 'course'},
        {text: '一對一課程', value: 'course-single'},
        {text: '一對多課程', value: 'course-multi'},
      ],
    };
  },
  computed: {
    ...mapState("general", {
      organization: (state) => state.organization,
    }),
    ...mapGetters("route", ["routeQuery"]),
    ...mapGetters("general", ["myBranches"]),
    readonly() {
      return this.$route.name === "ProductDetailV2"
    },
    isEdit() {
      return this.$route.name === "ProductEditV2"
    },
    isCreate() {
      return this.$route.name === "ProductCreateV2"
    },
    canEditAllFields() {
      return this.checkPermission([consts.PRODUCT_MODIFY]);
    },
    canEditStockFields() {
      return this.canEditAllFields || this.checkPermission([consts.PRODUCT_STOCK_MODIFY]);
    },
    canEditAnyFields() {
      return this.canEditAllFields || this.canEditStockFields;
    },
    branchOptions() {
      return [
        ...this.myBranches.map((branch) => ({ value: branch.id, text: `${branch.branch_code} ${branch.name}` })),
      ];
    },
    selectedBranchId() {
      return this.selectBranch?.value ?? null
    },
  },
  mounted() {
    if (!this.isCreate) {
      this.fetchProduct()
    }
    this.fetchMyBranch()

    if (this.isCreate) {
      if (this.$route.query.merchant_id) {
        this.product.merchant_id = this.$route.query.merchant_id;
      }

      if (this.$route.query.branch_id) {
        this.product.branch_id = this.$route.query.branch_id;
      }
    }

    if (this.$route.query.is_branch_product) {
      this.isBranchProduct = this.$route.query.is_branch_product;
    }

    if (this.isBranchProduct && this.$route.query.branch_id) {
      this.selectedBranch = this.branchOptions.find(
        (option) => option.value === this.$route.query.branch_id
      );
    }
  },
  methods: {
    format,
    formatToDateObject(datetime) {
      if (!datetime) {
        return {
          date: null,
          time: {
            HH: "",
            mm: "",
          }
        }
      }
      return {
        date: new Date(datetime),
        time: {
          HH: String(getHours(new Date(datetime))).padStart(2, "0"),
          mm: String(getMinutes(new Date(datetime))).padStart(2, "0"),
        },
      }
    },
    async fetchProduct() {
      this.showLoading = true;

      try {
        const {data} = await productApi.getProduct(this.$route.params.product_id);
        this.product = data.data;
        this.product.branch_id = this.product.branch ? this.product.branch.id : '';
        this.product.available_start_at = this.formatToDateObject(this.product.available_start_at)
        this.product.available_end_at = this.formatToDateObject(this.product.available_end_at)

        this.selectedBranch = this.branchOptions.find(
          (option) => option.value === this.product.branch_id
        );
      } catch (error) {
        console.error(error);
        alert("取得群商品料錯誤");
      }
      this.showLoading = false;
    },
    async fetchMyBranch() {
      if (this.branches.length > 0) {
        return;
      }
      console.log('go fetch my branch')
      try {
        const {data} = await branchApi.getCurrentBelowBranches();
        data.data.forEach((branch) => {
          if (branch.org_id === this.organization.id) {
            this.branches.push({
              text: branch.name,
              value: branch.id,
            });
          }
        });
      } catch (error) {
        console.log(error);
        alert("取得分店資料錯誤");
      }
    },
    handleCancel() {
      this.$router.push({ name: "ProductList", query: this.routeQuery });
    },
    formatToDatetimeString(datetime) {
      if (!datetime || !datetime.date) {
        return null;
      }
      return formatISO(
        set(new Date(datetime.date), {
            hours: Number(datetime.time.HH) || 0,
            minutes: Number(datetime.time.mm) || 0,
            seconds: 0,
          },
        )
      )
    },
    async handleSubmit() {
      this.showLoading = true;

      if (!this.canEditAnyFields) {
        this.showLoading = false;
        return;
      }

      if (this.canEditAllFields) {
        if (typeof this.product.title === 'undefined' || this.product.title === '') {
          this.$swal.fire({
            icon: "error",
            text: "商品名稱必填",
            type: "error",
            confirmButtonText: "確定"
          });
          this.showLoading = false;
          return;
        }

        if (isNaN(Number(this.product.price)) || Number(this.product.price) < 0) {
          this.$swal.fire({
            icon: "error",
            text: "售價必須輸入有效的數字",
            type: "error",
            confirmButtonText: "確定"
          });
          this.showLoading = false;
          return;
        }

        if (isNaN(Number(this.product.original_price)) || Number(this.product.original_price) < 0) {
          this.$swal.fire({
            icon: "error",
            text: "原價必須輸入有效的數字",
            type: "error",
            confirmButtonText: "確定"
          });
          this.showLoading = false;
          return;
        }

        if (Number(this.product.price) > Number(this.product.original_price)) {
          this.$swal
            .fire({
              icon: "error",
              text: "售價不得大於原價",
              type: "error",
              confirmButtonText: "確定"
            });
          this.showLoading = false;
          return;
        }

        if (isNaN(Number(this.product.point)) || Number(this.product.point) < 0) {
          this.$swal.fire({
            icon: "error",
            text: "點數必須輸入有效的數字",
            type: "error",
            confirmButtonText: "確定"
          });
          this.showLoading = false;
          return;
        }
      }

      if (this.product.skus.length > 0) {
        for (let i = 0; i < this.product.skus.length; i++) {
          const sku = this.product.skus[i];

          if (this.canEditAllFields && !sku.sku_code) {
            this.$swal.fire({
              icon: "error",
              text: `第 ${i + 1} 筆 商品規格 的規格序號為必填`,
              type: "error",
              confirmButtonText: "確定"
            });
            this.showLoading = false;
            return;
          }

          if (this.canEditAllFields && !sku.sku_name) {
            this.$swal.fire({
              icon: "error",
              text: `第 ${i + 1} 筆 商品名稱 的規格名稱為必填`,
              type: "error",
              confirmButtonText: "確定"
            });
            this.showLoading = false;
            return;
          }

          if (sku.max_quantity === "" || isNaN(Number(sku.max_quantity)) || Number(sku.max_quantity) < 0) {
            this.$swal.fire({
              icon: "error",
              text: `第 ${i + 1} 筆 商品規格 的原始總量必須是有效的數字`,
              type: "error",
              confirmButtonText: "確定"
            });
            this.showLoading = false;
            return;
          }

          if (sku.quantity === "" || isNaN(Number(sku.quantity)) || Number(sku.quantity) < 0) {
            this.$swal.fire({
              icon: "error",
              text: `第 ${i + 1} 筆 商品規格 的可售庫存必須是有效的數字`,
              type: "error",
              confirmButtonText: "確定"
            });
            this.showLoading = false;
            return;
          }

          // 確保兩個值都是數字
          if (this.canEditAllFields && (sku.suggest_price === "" || isNaN(Number(sku.suggest_price)) || Number(sku.suggest_price) < 0)) {
            this.$swal.fire({
              icon: "error",
              text: `第 ${i + 1} 筆 商品規格 的售價必須是有效的數字`,
              type: "error",
              confirmButtonText: "確定"
            });
            this.showLoading = false;
            return;
          }

          if (this.canEditAllFields && (sku.price === "" || isNaN(Number(sku.price)) || Number(sku.price) < 0)) {
            this.$swal.fire({
              icon: "error",
              text: `第 ${i + 1} 筆 商品規格 的原價必須是有效的數字`,
              type: "error",
              confirmButtonText: "確定"
            });
            this.showLoading = false;
            return;
          }

          if (this.canEditAllFields && Number(sku.suggest_price) > Number(sku.price)) {
            this.$swal.fire({
              icon: "error",
              text: `第 ${i + 1} 筆 商品規格 的建議售價不能大於售價`,
              type: "error",
              confirmButtonText: "確定"
            });
            this.showLoading = false;
            return;
          }

          if (this.canEditAllFields && (sku.point === "" || isNaN(Number(sku.point)) || Number(sku.point) < 0)) {
            this.$swal.fire({
              icon: "error",
              text: `第 ${i + 1} 筆 商品規格 的點數必須是有效的數字`,
              type: "error",
              confirmButtonText: "確定"
            });
            this.showLoading = false;
            return;
          }
        }
      }

      if (this.isEdit) {
        await this.goUpdate()
      }
      if (this.isCreate) {
        await this.goCreate()
      }

      this.showLoading = false;
    },
    async goUpdate() {
      let productData = {
        ...this.product, // 保留原始 product 的所有欄位
        available_start_at: this.formatToDatetimeString(this.product.available_start_at),
        available_end_at: this.formatToDatetimeString(this.product.available_end_at),
      };

      try {
        await productApi.updateProduct(productData.id, productData);
        this.$swal
          .fire({
            icon: "success",
            text: "更新成功",
          })
          .then(() => {
            if (this.isBranchProduct) {
              this.$router.push({ name: "BranchProductList", query: this.routeQuery });
            } else {
              this.$router.push({ name: "ProductList", query: this.routeQuery });
            }
          });
      } catch (error) {
        const errorMessage =
          (error && error.response && error.response.data && error.response.data.message) ||
          (error && error.response && error.response.data && error.response.data.error && error.response.data.error.message) ||
          (error && error.message) ||
          "未知錯誤";

        this.$swal.fire({
          icon: "error",
          type: "error",
          title: "更新失敗",
          text: errorMessage === "Permission exception" ? "Permission exception" : errorMessage,
          confirmButtonText: "確定",
        });
        console.error(error);
      }
    },
    async goCreate() {
      let productData = {
        ...this.product, // 保留原始 product 的所有欄位
        available_start_at: this.formatToDatetimeString(this.product.available_start_at),
        available_end_at: this.formatToDatetimeString(this.product.available_end_at),
      };

      try {
        await productApi.createProduct(productData);
        this.$swal
          .fire({
            icon: "success",
            text: "新增成功",
          })
          .then(() => {
            if (this.isBranchProduct) {
              this.$router.push({ name: "BranchProductList", query: this.routeQuery });
            } else {
              this.$router.push({ name: "ProductList", query: this.routeQuery });
            }
          });
      } catch (error) {
        console.error(error);
      }
    },
    addSkuHandler() {
      this.product.skus.push({
        id: null,
        sku_code: null,
        sku_name: null,
        sku_outer_code: null,
        max_quantity: 0,
        quantity: 0,
        suggest_price: 0,
        price: 0,
        point: 0,
      })
    },
    removeItemHandler(index) {
      this.product.skus = this.product.skus.filter((item, i) => i !== index);
      this.$emit('input', this.product);
    },
    delete1(index) {
      // 確保 index 是有效的，防止出錯
      if (index >= 0 && index < this.product.skus.length) {
        this.product.skus.splice(index, 1);  // 刪除指定索引的元素
      } else {
        console.log("無效的索引:", index);
      }
    },
    async handleBranchChange() {
      this.product.branch_id = this.selectedBranchId
    },
    checkPermission(permissions) {
      return this.permissionChecker.check(permissions);
    },
  },
};
</script>
<style>
.wide-col {
  width: 30%; /* 調整寬度為所需百分比 */
}

.narrow-column {
  width: 12%; /* 調整寬度為所需百分比 */
}
</style>
